import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const email = localStorage.getItem('userEmail');
    
    if (!isLoggedIn || !email) {
      navigate('/login');
      return;
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Fermer la sidebar sur mobile si on passe du desktop au mobile
      if (window.innerWidth <= 768 && sidebarOpen) {
        // Ne pas fermer automatiquement, laisser l'utilisateur le faire
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [navigate, sidebarOpen]);

  const sidebarItems = [
    { 
      id: 'dashboard', 
      label: 'Dashboard', 
      icon: 'fas fa-tachometer-alt',
      color: '#96ca2d',
      path: '/admin/dashboard'
    },
    { 
      id: 'news', 
      label: 'News', 
      icon: 'fas fa-newspaper',
      color: '#96ca2d',
      path: '/admin/news'
    },
    { 
      id: 'categories', 
      label: 'Categories', 
      icon: 'fas fa-tags',
      color: '#96ca2d',
      path: '/admin/categories'
    },
    { 
      id: 'events', 
      label: 'Events', 
      icon: 'fas fa-calendar-alt',
      color: '#96ca2d',
      path: '/admin/events'
    },
    { 
      id: 'resources', 
      label: 'Resources', 
      icon: 'fas fa-folder-open',
      color: '#96ca2d',
      path: '/admin/resources'
    },
    { 
      id: 'deliverables', 
      label: 'Deliverables', 
      icon: 'fas fa-file-alt',
      color: '#96ca2d',
      path: '/admin/deliverables'
    },
    { 
      id: 'partners', 
      label: 'Partners', 
      icon: 'fas fa-handshake',
      color: '#96ca2d',
      path: '/admin/partners'
    },
    { 
      id: 'comments', 
      label: 'Comments', 
      icon: 'fas fa-comments',
      color: '#96ca2d',
      path: '/admin/comments'
    },
    { 
      id: 'settings', 
      label: 'Settings', 
      icon: 'fas fa-cog',
      color: '#96ca2d',
      path: '/admin/settings'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    // Fermer la sidebar sur mobile après navigation
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Overlay pour mobile */}
      {sidebarOpen && isMobile && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998
          }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: sidebarOpen ? '280px' : (isMobile ? '0' : '70px'),
        background: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease',
        zIndex: 1001,
        overflow: 'hidden',
        transform: isMobile && !sidebarOpen ? 'translateX(-100%)' : 'translateX(0)'
      }}>
        {/* Header */}
        <div style={{
          height: '64px',
          padding: isMobile ? '0 16px' : '0 24px',
          borderBottom: '1px solid #f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#fafafa'
        }}>
          {sidebarOpen && (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: isMobile ? 'center' : 'flex-start',
              alignItems: 'flex-start',
              height: '100%',
              margin: 0,
              paddingTop: '20px' 
            }}>
              <Link 
                to="/"
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: '0 0 1px 0',
                  padding: 0,
                  color: '#1f2937',
                  letterSpacing: '-0.025em',
                  lineHeight: '1.2',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#96ca2d';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#1f2937';
                }}
              >
                MedAgriCycle
              </Link>
              <p style={{
                fontSize: '11px',
                margin: 0,
                padding: 0,
                color: '#6b7280',
                fontWeight: '400',
                lineHeight: '1.2'
              }}>
                Admin Panel
              </p>
            </div>
          )}
          
          {!sidebarOpen && (
            <div style={{
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} />
          )}
          
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{
              background: '#ffffff',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              width: '36px',
              height: '36px',
              color: '#6b7280',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#96ca2d';
              e.target.style.color = '#96ca2d';
              e.target.style.boxShadow = '0 1px 3px rgba(150, 202, 45, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.color = '#6b7280';
              e.target.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
            }}
          >
            <i className={`fas fa-${sidebarOpen ? 'chevron-left' : 'chevron-right'}`} style={{ fontSize: '14px' }} />
          </button>
        </div>

        {/* Navigation */}
        <nav style={{
          padding: '16px 12px',
          flex: 1,
          overflowY: 'auto'
        }}>
          <div style={{ display: 'grid', gap: '4px' }}>
            {sidebarItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavigation(item.path)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: sidebarOpen ? '12px' : '0',
                  padding: sidebarOpen ? '12px 16px' : '12px',
                  margin: '0 4px',
                  background: isActive(item.path) 
                    ? '#f0fdf4' 
                    : 'transparent',
                  border: isActive(item.path) 
                    ? '1px solid #96ca2d' 
                    : '1px solid transparent',
                  borderRadius: '8px',
                  color: isActive(item.path) ? '#96ca2d' : '#374151',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  position: 'relative',
                  justifyContent: sidebarOpen ? 'flex-start' : 'center',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  if (!isActive(item.path)) {
                    e.target.style.background = '#f9fafb';
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.color = '#96ca2d';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive(item.path)) {
                    e.target.style.background = 'transparent';
                    e.target.style.borderColor = 'transparent';
                    e.target.style.color = '#374151';
                  }
                }}
              >
                <div style={{
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  color: isActive(item.path) ? '#96ca2d' : '#6b7280'
                }}>
                  <i className={item.icon} />
                </div>
                
                {sidebarOpen && (
                  <span style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}>
                    {item.label}
                  </span>
                )}

                {/* Indicateur actif */}
                {isActive(item.path) && (
                  <div style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '4px',
                    height: '4px',
                    background: '#96ca2d',
                    borderRadius: '50%'
                  }} />
                )}
              </button>
            ))}
          </div>
        </nav>
      </div>

    </>
  );
};

export default Sidebar;